import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted } from 'vue'
import QSummitSidebarHeader from './QSummitSidebarHeader.vue'
import QSummitExpansionPanel from './accordion/ExpansionPanel.vue'

import SummitNav from '@/store/Models/SummitNav'

import { Step } from './Step'
import { phases } from '../phases'


export default /*#__PURE__*/_defineComponent({
  __name: 'QSummitSidebar',
  setup(__props) {

const steps = computed(() => SummitNav.query().orderBy('StepOrder').get() as unknown as Step[])
const currentStep = computed(() => steps.value.find((step) => step.CurrentStepInd) || steps.value[0])

const categoriesStepsMap = computed(() => {
    const map = {} as Record<string, Step[]>
    steps.value.forEach((step) => {
        if (!map[step.StepCategory]) {
            map[step.StepCategory] = []
        }
        map[step.StepCategory].push(step)
    })
    return map
})

const categoriesList = computed(() => Object
    .keys(categoriesStepsMap.value)
    .sort((a, b) => phases.indexOf(a.toLowerCase().replaceAll(/ /g, '')) - phases.indexOf(b.toLowerCase().replaceAll(/ /g, '')))
)

const openPanel = ref(-1)

onMounted(() => {
    openPanel.value = categoriesList.value.findIndex((c) => c === currentStep.value.StepCategory)
})

return { __sfc: true,steps, currentStep, categoriesStepsMap, categoriesList, openPanel, QSummitSidebarHeader, QSummitExpansionPanel }
}

})